import Vue from 'vue'
import Router from 'vue-router'
Vue.use(Router)

export const constantRoutes = [
    {
        path: '/',
        name: 'home',
        component: () => import('@/views/index.vue'),
        title: '首页'
    }, {
        path: '/mine',
        name: 'mine',
        // redirect: '/orations',
        component: () => import('@/views/aboutUs/index.vue'),  
        title: '关于帕菲特',
        children: [
            {
                path: '/companyProfile',
                name: 'companyProfile',
                component: () => import('@/views/aboutUs/companyProfile.vue'),
                title: '公司简介',
            }, {
                path: '/orations',
                name: 'orations',
                component: () => import('@/views/aboutUs/oration.vue'),
                title: '领导致辞',
            }, {
                path: '/environment',
                name: 'environment',
                component: () => import('@/views/aboutUs/environment.vue'),
                title: '公司环境',
            },{
                path: '/videos',
                name: 'videos',
                component: () => import('@/views/aboutUs/mine.vue'),
                title: '视频中心',
            },{
                path: '/messages',
                name: 'messages',
                component: () => import('@/views/message.vue'),
                title: '留言',
            }, {
                path: '/productCenters',
                title: '产品中心',
                name: 'productCenters',
                component: () => import('@/views/productCenter/index.vue'),
        
            },
        ]
    }, {
        path: '/productCenter',
        title: '产品中心',
        name: 'productCenter',
        component: () => import('@/views/productCenter/index.vue'),

    }, {
        path: '/productIndex',
        name: 'productIndex',
        redirect: '/productList',
        component: () => import('@/views/productCenter/listIndex.vue'),
        title: '产品列表',
        children: [
            {
                path: '/productList',
                name: 'productList',
                component: () => import('@/views/productCenter/list.vue'),
                title: '产品列表',
            }, {
                path: '/productInfo',
                name: 'productInfo',
                component: () => import('@/views/productCenter/info.vue'),
                title: '产品详情',
            },
        ]
    }, {
        path: '/cowboyOnly',
        title: '牛仔专用',
        name: 'cowboyOnly',
        component: () => import('@/views/cowboyOnly/index.vue')
    },{
        path: '/video',
        name: 'video',
        component: () => import('@/views/aboutUs/mine.vue'),
        title: '视频中心',
    },{
        path: '/message',
        name: 'message',
        component: () => import('@/views/message.vue'),
        title: '留言',
    },{
        path: '/oration',
        name: 'oration',
        component: () => import('@/views/aboutUs/oration.vue'),
        title: '单页',
    }, {
        path: '/news',
        name: 'news',
        redirect: '/newsList',
        component: () => import('@/views/news/index.vue'),
        title: '新闻',
        children: [
            {
                path: '/newsList',
                name: 'newsList',
                component: () => import('@/views/news/newsList.vue'),
                title: '新闻列表',
            }, {
                path: '/newsInfo',
                name: 'newsInfo',
                component: () => import('@/views/news/newsInfo.vue'),
                title: '新闻详情',
            },
        ]
    },
]
const createRouter = () => new Router({
    mode: 'hash',
    scrollBehavior: () => ({
        y: 0
    }),
    routes: constantRoutes
})

const router = createRouter()
export function resetRouter() {
    const newRouter = createRouter()
    router.matcher = newRouter.matcher // reset router
}

export default router